import { render, staticRenderFns } from "./PN.vue?vue&type=template&id=3a210f1e&scoped=true&"
import script from "./PN.vue?vue&type=script&lang=js&"
export * from "./PN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a210f1e",
  null
  
)

export default component.exports